import script from "./language_picker.vue?vue&type=script&setup=true&lang=js"
export * from "./language_picker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__